module.exports = __webpack_public_path__ + "3a2bea20352c9b94d884d77fceee6a21.svg";